import * as React from 'react';
import { Box, Button, Grid, Skeleton, TextField } from "@mui/material";
import { useState } from 'react';
import { escalationRateRegex } from '../componentsConfig/utils';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GetEscalation, UpdateEscalation } from '../../../graphql/queries_escalation';
import { apiRequest } from '../../../services/utils/HttpUtils';
import { useMsal } from "@azure/msal-react";
import { escalationText,escalationTexttwo} from "../../../assets/texts/pageTextContent";

type Props = {
    onTabChange: (index: number) => void,
    scenarioID: string
}

const EscalationRate = ({ onTabChange, scenarioID }: Props) => {
    const [escalationRate, setEscalationRate] = useState("");
    const { instance, accounts } = useMsal();
    const client = useQueryClient();

    const handleEscalationRateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (escalationRateRegex.test(event.target.value)) {
            setEscalationRate(event.target.value);
        }
    }

    const handleGenerateScenario = () => {
        // save escalation rate
        updateEscalation.mutate({
            inScenarioID: scenarioID,
            inEscalation: escalationRate
        })
        onTabChange(3)
    }
    // react-query to fetch escalation rate
    const { data, isFetching } = useQuery({
        queryKey: ["escalationRate"],
        queryFn: () => {
            return apiRequest({
                query: GetEscalation,
                variables: {
                    inScenarioID: scenarioID
                },
                instance: instance,
                accounts: accounts
            })
        },
        cacheTime: Infinity,
        onSuccess: (data) => {
            //@ts-ignore
            if (data.executeGetEscalation.length > 0 && data.executeGetEscalation[0].AnnualEscalation) {
                //@ts-ignore
                setEscalationRate(data.executeGetEscalation[0].AnnualEscalation);
            }
        }
    })

    const updateEscalation = useMutation(["updateEscalation"], {
        mutationFn: (variables: any) => {
            return apiRequest({
                query: UpdateEscalation,
                variables: variables,
                instance: instance,
                accounts: accounts
            })
        },
        onSuccess: () => {
            client.invalidateQueries(["escalationRate"]);
        }
    })
    return (
        <>
            <Box p={1} sx={{ minHeight: "50vh" }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                    {escalationText}
                    <br />
                    {escalationTexttwo}
                    </Grid>
                    <Grid item>
                        Delta Escalation
                    </Grid>
                    {!isFetching ? <Grid item>
                        <TextField
                            id="escalation-input"
                            value={escalationRate}
                            onChange={handleEscalationRateChange}
                            sx={{
                                width: 70,
                                height: '30px',
                                // Adjust the height as needed
                                '& .MuiInputBase-root': {
                                    height: '30px', // Ensure the inner input matches the desired height
                                    fontSize: '0.875rem', // Adjust font size if needed
                                },
                                mr: 1,
                            }}
                            size="small"
                        />%
                    </Grid> : <Grid item><Skeleton variant='text' width={70} height="30px" /></Grid>}

                </Grid>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button variant="contained" onClick={handleGenerateScenario}>
                    Generate scenario
                </Button>
            </Box>
        </>);
}

export default EscalationRate;


